/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menutakephoto2Inputs */

const en_menutakephoto2 = /** @type {(inputs: Menutakephoto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a photo`)
};

const de_menutakephoto2 = /** @type {(inputs: Menutakephoto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto aufnehmen`)
};

/**
* | output |
* | --- |
* | "Take a photo" |
*
* @param {Menutakephoto2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menutakephoto2 = /** @type {((inputs?: Menutakephoto2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menutakephoto2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menutakephoto2(inputs)
	return de_menutakephoto2(inputs)
});
export { menutakephoto2 as "menuTakePhoto" }